module.exports = __webpack_public_path__ + "fonts/iconfont.4183fbb7.ttf";